import createReducer from './_createReducerHelper';

export const USER = 'user/USER';

const initialState = {
  user: null,
};

/** ********************************************
 * reducer
 ******************************************** */

export default createReducer(initialState, {
  [USER]: (state, { payload }) => ({ ...state, user: payload }),
});

/** ********************************************
 * actions
 ******************************************** */

/**
 *
 * @param user
 * @return {{type, payload: *}}
 */
export const setUser = (user) => ({
  type: USER,
  payload: user,
});

/** ********************************************
 * selectors
 ******************************************** */

/**
 *
 * @param state
 */
export const readStateUser = (state) => state.user.user;
